import { makeAutoObservable } from "mobx";
import { PPaymentMediumGenerator } from "./PPaymentMedium";
export class PRestaurant {
    constructor(params) {
        this.domain = params.domain;
        this.productTypes = params.productTypes;
        this.modifierTypes = params.modifierTypes;
        this.customParameterTypes = params.customParameterTypes;
        this.name = params.name;
        this.menu = params.menu;
        this.address = params.address; // TODO: unify PRestaurantAddress with this model and use the only one?
        this.promotionTypes = params.promotionTypes;
        this.orderingAvailability = params.orderingAvailability;
        this.isApplePaySupported = params.isApplePaySupported;
        makeAutoObservable(this);
    }
    get id() {
        return this.domain.id;
    }
    get openingHour() {
        return this.orderingAvailability !== null &&
            this.orderingAvailability.tag === "OrderingPossible"
            ? this.orderingAvailability.nextAvailableThatDay
            : null;
    }
    get enableFod() {
        return this.domain.orderingPolicy.enableFod;
    }
    get enableMarketingConsents() {
        return this.domain.orderingPolicy.enableMarketingConsents;
    }
    get franchiseName() {
        return this.domain.franchiseName;
    }
    get paymentMediums() {
        const { paymentChannels, paymentMethods } = this.domain;
        if (paymentChannels === null || paymentMethods === null) {
            return null;
        }
        return PPaymentMediumGenerator.group({
            paymentChannels,
            paymentMethods,
            includeApplePay: this.isApplePaySupported,
        });
    }
    get maxOrderValue() {
        return this.domain.orderingPolicy.maxOrderValue;
    }
}
